var _defs, _ellipse, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDoctorError(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 232.62 275.31",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-14,.cls-15{fill:none;}.cls-2{fill:#f5f5f5;}.cls-3{fill:#f2f2f2;}.cls-11,.cls-12,.cls-13,.cls-14,.cls-15,.cls-16,.cls-3,.cls-6,.cls-7,.cls-8,.cls-9{stroke:#2a3561;stroke-miterlimit:10;stroke-width:0.5px;}.cls-4{clip-path:url(#clip-path);}.cls-13,.cls-5{fill:#2a3561;}.cls-6{fill:#acc1cd;}.cls-7{fill:#31f4cf;}.cls-8{fill:#37a7f4;}.cls-9{fill:#d8e2e8;}.cls-10{clip-path:url(#clip-path-3);}.cls-11{fill:#2b5889;}.cls-12{fill:#ffc99d;}.cls-12,.cls-14{stroke-linecap:round;}.cls-16{fill:#fff;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 131.13,
    cy: 233.72,
    rx: 101.24,
    ry: 34.29
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M22.87,55.72v178h7C29.87,252.66,75.2,268,131.12,268s101.24-15.35,101.24-34.29v-178Z"
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ELEMENTS") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse",
    className: "cls-2",
    cx: 112.04,
    cy: 112.61,
    rx: 112.04,
    ry: 112.61
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "not_found",
    "data-name": "not found"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_10",
    "data-name": "Ellipse 10",
    className: "cls-3",
    cx: 131.13,
    cy: 233.72,
    rx: 101.24,
    ry: 34.29
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_103",
    "data-name": "Group 103"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_101",
    "data-name": "Group 101"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_11",
    "data-name": "Ellipse 11",
    className: "cls-5",
    cx: 133.66,
    cy: 268,
    rx: 60.8,
    ry: 20.59
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_102",
    "data-name": "Group 102"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_388",
    "data-name": "Path 388",
    className: "cls-6",
    d: "M84.28,203.31l65.94,114.56h12.44L94.89,201.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_389",
    "data-name": "Path 389",
    className: "cls-7",
    d: "M55.19,225.4l34.86-12.89A3.44,3.44,0,0,1,94.2,214h0A3.43,3.43,0,0,1,93,218.7a2.65,2.65,0,0,1-.48.23L58.16,232.62A3.45,3.45,0,0,1,54,231.27l-.5-.79a3.43,3.43,0,0,1,1.05-4.75A3.7,3.7,0,0,1,55.19,225.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_390",
    "data-name": "Path 390",
    className: "cls-7",
    d: "M65.21,243.07l34.86-12.89a3.46,3.46,0,0,1,4.16,1.48h0a3.44,3.44,0,0,1-1.21,4.71,3.49,3.49,0,0,1-.48.23L68.19,250.29A3.44,3.44,0,0,1,64,248.94l-.51-.79a3.44,3.44,0,0,1,1-4.75A4.07,4.07,0,0,1,65.21,243.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_391",
    "data-name": "Path 391",
    className: "cls-7",
    d: "M76.59,262.08l34.85-12.89a3.44,3.44,0,0,1,4.16,1.47h0a3.44,3.44,0,0,1-1.22,4.71,4.16,4.16,0,0,1-.47.24L79.55,269.29A3.44,3.44,0,0,1,75.38,268l-.51-.79a3.46,3.46,0,0,1,1.06-4.76A3.35,3.35,0,0,1,76.59,262.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_392",
    "data-name": "Path 392",
    className: "cls-8",
    d: "M94.41,287.54l34.86-12.9a3.46,3.46,0,0,1,4.16,1.48h0a3.44,3.44,0,0,1-1.22,4.71,4.16,4.16,0,0,1-.47.24L97.38,294.75a3.44,3.44,0,0,1-4.18-1.35l-.5-.79a3.44,3.44,0,0,1,1.06-4.75A3,3,0,0,1,94.41,287.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_394",
    "data-name": "Path 394",
    className: "cls-9",
    d: "M42.64,217.05l63.87,111H119L51.55,212.52Z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_109",
    "data-name": "Group 109"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_108",
    "data-name": "Group 108"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_105",
    "data-name": "Group 105"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_395",
    "data-name": "Path 395",
    className: "cls-11",
    d: "M153.79,228.05s-13.42-61.9-18-76.54a40.34,40.34,0,0,0-4.43-9.84H133l-8.92-8.92A83.32,83.32,0,0,1,103.44,135a121,121,0,0,1-15.08-1.45L81,132.75l-.94,3.48-.7,0,.28,1.55-1,3.88h1.74L95.54,226Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_396",
    "data-name": "Path 396",
    className: "cls-8",
    d: "M95.54,226l10.14,55.3,27.14-.49-11.65-56.53Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_104",
    "data-name": "Group 104"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_397",
    "data-name": "Path 397",
    className: "cls-12",
    d: "M105.92,143.61H104a5,5,0,0,1-5-5h0V124.05h11.91v14.53a5,5,0,0,1-5,5Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_398",
    "data-name": "Path 398",
    className: "cls-5",
    d: "M99,131.51s1.08,3.3,6,4.76,6,.32,6,.32v-5.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_399",
    "data-name": "Path 399",
    className: "cls-12",
    d: "M105,96.25c-14.52,0-13.13,8.79-13.13,8.79v17.87c0,10.18,13.13,10.61,13.13,10.61s13.13-.43,13.13-10.61V105S119.5,96.25,105,96.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_400",
    "data-name": "Path 400",
    className: "cls-13",
    d: "M101.4,102.43s4.37,4.85,16.71,4.85l0,4.43,2.83-1a96.22,96.22,0,0,1-1.06-11.11c0-4.29-6.74-6.31-15.67-6.31s-14.2,3.81-14.2,7.07-.83,10.14-.83,10.14l2.61,1.33v-6.82S95.16,106.07,101.4,102.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_401",
    "data-name": "Path 401",
    className: "cls-12",
    d: "M118.15,110.53s2.51-1.48,3.38,1.26c1.12,3.58-3.38,6.63-3.38,6.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_402",
    "data-name": "Path 402",
    className: "cls-12",
    d: "M91.83,110.53s-2.52-1.48-3.39,1.26c-1.12,3.58,3.39,6.63,3.39,6.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_403",
    "data-name": "Path 403",
    className: "cls-12",
    d: "M104.67,112.81,102,120.72a1.69,1.69,0,0,0,1,2.14,1.76,1.76,0,0,0,.55.09h2.29"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_404",
    "data-name": "Path 404",
    className: "cls-8",
    d: "M152.66,222.84l-33.93-14s-9-2.15-12.2,7l-5.64,24.25L94.8,269l21.8,4.06L124,238.75l1.14,4.88s11.9-.28,20.67,0a9.2,9.2,0,0,0,9.53-8.84,9,9,0,0,0-.29-2.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_405",
    "data-name": "Path 405",
    className: "cls-12",
    d: "M68.31,163.56l-1.52,11.73L56,151.51H41.32L59.15,190.8a9.52,9.52,0,0,0,4,4.41l.12.07a9.65,9.65,0,0,0,10.52-1l1.56-1.22A9.82,9.82,0,0,0,79,186.21l1.78-21.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_406",
    "data-name": "Path 406",
    className: "cls-11",
    d: "M88.36,133.59l-5.77-1s-11-1.7-13.38,8.73l-6.65,23.92L80.62,170l4-18.77"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_407",
    "data-name": "Path 407",
    className: "cls-12",
    d: "M155.46,154.62l6.68,9.77L161,138.28l13.05-6.63,1.9,43.13a9.43,9.43,0,0,1-1.56,5.74,1.05,1.05,0,0,0-.07.11,9.62,9.62,0,0,1-9.79,3.87l-2-.39a9.69,9.69,0,0,1-6.36-4.43L144.8,161.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_408",
    "data-name": "Path 408",
    className: "cls-11",
    d: "M121.13,133.45s12.61-4.69,17.64-.12,22,23.83,22,23.83l-16.17,11.29-7.3-10.56-6.14-8.78"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_64",
    "data-name": "Line 64",
    className: "cls-14",
    x1: 124.02,
    y1: 238.76,
    x2: 127.09,
    y2: 226.56
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_106",
    "data-name": "Group 106"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_409",
    "data-name": "Path 409",
    className: "cls-12",
    d: "M161,139a19.72,19.72,0,0,1,1.52-7.66c1.61-3.39,14.23-12.06,15-12.59,1.91-1.39,3.62,1,3.62,1l6.19-3.65a4.4,4.4,0,0,1,4.31,1.31c1.69,2,1.67,6.18.7,7.44s-11.62,9-11.62,9-4.49,4.47-6.18,8.15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_410",
    "data-name": "Path 410",
    className: "cls-12",
    d: "M179.31,121a45,45,0,0,1,4.85,7.86"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_411",
    "data-name": "Path 411",
    className: "cls-12",
    d: "M180.84,123.08a99.93,99.93,0,0,0,10-6.32"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_412",
    "data-name": "Path 412",
    className: "cls-14",
    d: "M181.13,119.8l-9.41,7a5.88,5.88,0,0,1,1.12,6"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_65",
    "data-name": "Line 65",
    className: "cls-14",
    x1: 183.62,
    y1: 127.7,
    x2: 192.98,
    y2: 121.56
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_413",
    "data-name": "Path 413",
    className: "cls-12",
    d: "M192.34,118.65s-3,2.51-4.51,3.45-5.61,3.12-5.61,3.12"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_107",
    "data-name": "Group 107"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_414",
    "data-name": "Path 414",
    className: "cls-12",
    d: "M57.64,155.37a41.39,41.39,0,0,0-3.12-8.19c-1.83-3.26-14-10.38-14.71-10.86-2-1.26-3.54,1.24-3.54,1.24l-6.43-3.2a4.39,4.39,0,0,0-4.21,1.6c-1.53,2.14-1.23,6.27-.18,7.47s12.22,8.14,12.22,8.14,5.19,4.07,7.13,7.63"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_415",
    "data-name": "Path 415",
    className: "cls-12",
    d: "M38.17,138.59a45.35,45.35,0,0,0-4.3,8.19"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_416",
    "data-name": "Path 416",
    className: "cls-12",
    d: "M36.78,140.81a98.7,98.7,0,0,1-10.43-5.61"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_417",
    "data-name": "Path 417",
    className: "cls-14",
    d: "M36.27,137.57l9.85,6.3a5.88,5.88,0,0,0-.7,6"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_66",
    "data-name": "Line 66",
    className: "cls-14",
    x1: 34.33,
    y1: 145.63,
    x2: 24.58,
    y2: 140.15
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_418",
    "data-name": "Path 418",
    className: "cls-12",
    d: "M25,137.19s3.17,2.3,4.73,3.13,5.81,2.73,5.81,2.73"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_110",
    "data-name": "Group 110"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_31",
    "data-name": "Rectangle 31",
    className: "cls-7",
    x: 114.33,
    y: 162.82,
    width: 14.43,
    height: 7
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_14",
    "data-name": "Ellipse 14",
    className: "cls-7",
    cx: 121.54,
    cy: 162.06,
    r: 2.46
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_420",
    "data-name": "Path 420",
    className: "cls-15",
    d: "M98.89,129.11a6.26,6.26,0,0,1,5.3-2.66,7.89,7.89,0,0,1,5.83,2.66"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_67",
    "data-name": "Line 67",
    className: "cls-14",
    x1: 66.78,
    y1: 175.29,
    x2: 71.05,
    y2: 185.17
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_68",
    "data-name": "Line 68",
    className: "cls-14",
    x1: 162.14,
    y1: 164.4,
    x2: 162.9,
    y2: 175.29
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_111",
    "data-name": "Group 111"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_421",
    "data-name": "Path 421",
    className: "cls-16",
    d: "M195,175.84a5.48,5.48,0,0,0-4.49,3.68A4.18,4.18,0,0,0,187,183c-.81,3.31,1,5.47,3.23,5.65a6,6,0,0,0,4.76,3.86c4,.81,7.44-3.32,6.1-9.06C201.11,183.47,202.32,175.39,195,175.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_422",
    "data-name": "Path 422",
    className: "cls-16",
    d: "M198,181.18s1.52.1,3.14,2.29"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_423",
    "data-name": "Path 423",
    className: "cls-16",
    d: "M190.52,179.52a7.58,7.58,0,0,0-1,4.7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_424",
    "data-name": "Path 424",
    className: "cls-16",
    d: "M193.3,183.47a5,5,0,0,0,2.69,5.15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_425",
    "data-name": "Path 425",
    className: "cls-16",
    d: "M189.2,188.43a7.26,7.26,0,0,0,3.21.19,4.5,4.5,0,0,0,2.4-.8"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_426",
    "data-name": "Path 426",
    className: "cls-16",
    d: "M205.13,169.41a5.69,5.69,0,0,0-3.16-1c-1.35.19-.88,3.3,1,3.56S206.53,170.76,205.13,169.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_427",
    "data-name": "Path 427",
    className: "cls-16",
    d: "M146.72,120.7a5.75,5.75,0,0,0-3.16-1c-1.35.2-.88,3.3,1,3.57S148.13,122,146.72,120.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_428",
    "data-name": "Path 428",
    className: "cls-16",
    d: "M57.91,125.68a5.75,5.75,0,0,0-3.16-1c-1.34.2-.87,3.3,1,3.57S59.33,127,57.91,125.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_429",
    "data-name": "Path 429",
    className: "cls-16",
    d: "M178.15,199.43c-.33.07-4.13,1.8-3.32,4.67s5.38,1.62,5.65-1.07S179.94,199.06,178.15,199.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_430",
    "data-name": "Path 430",
    className: "cls-16",
    d: "M122.07,76.39c-.32.06-4.13,1.79-3.32,4.67s5.38,1.62,5.65-1.07S123.87,76,122.07,76.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_431",
    "data-name": "Path 431",
    className: "cls-16",
    d: "M45.25,177.1c-.32.07-4.13,1.8-3.32,4.68s5.38,1.61,5.65-1.08S47,176.75,45.25,177.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_432",
    "data-name": "Path 432",
    className: "cls-16",
    d: "M154.56,103.52a3.81,3.81,0,0,0-5.13-.9l-.08,0c-2.43,1.68-1.07,4.65-1.07,4.65a3.64,3.64,0,0,0-.81,3.77,3.78,3.78,0,0,0,4.71,2.35,17,17,0,0,0,3-1.41s3,1.62,5.12-.6a4.3,4.3,0,0,0-.43-6.06,4.38,4.38,0,0,0-1.86-.94c-3.23-.81-3.1-.4-3.1-.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_433",
    "data-name": "Path 433",
    className: "cls-16",
    d: "M154.56,103.52s1.17.65,1.17,3.43"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_434",
    "data-name": "Path 434",
    className: "cls-16",
    d: "M155.21,112A4.22,4.22,0,0,1,153,110"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_435",
    "data-name": "Path 435",
    className: "cls-16",
    d: "M148.28,107.32a7.52,7.52,0,0,0,.89,1.74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_436",
    "data-name": "Path 436",
    className: "cls-16",
    d: "M151.1,105.66a2.15,2.15,0,0,1,2.06,0"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_112",
    "data-name": "Group 112"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_437",
    "data-name": "Path 437",
    className: "cls-16",
    d: "M38.68,201.47a3.82,3.82,0,0,1,4.22-3.06H43c2.92.45,3,3.7,3,3.7a3.68,3.68,0,0,1,2.38,3,3.78,3.78,0,0,1-3.2,4.18,16.22,16.22,0,0,1-3.34.06s-2,2.74-4.86,1.69a4.3,4.3,0,0,1-1-7.29c2.55-2.13,2.61-1.72,2.61-1.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_438",
    "data-name": "Path 438",
    className: "cls-16",
    d: "M38.67,201.47s-.76,1.09.46,3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_439",
    "data-name": "Path 439",
    className: "cls-16",
    d: "M46,202.13a7.15,7.15,0,0,1,0,2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_440",
    "data-name": "Path 440",
    className: "cls-16",
    d: "M42.72,201.88a2.18,2.18,0,0,0-1.86.91"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_441",
    "data-name": "Path 441",
    className: "cls-16",
    d: "M38.44,208a5.12,5.12,0,0,0,3.37,1.38"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_114",
    "data-name": "Group 114"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_113",
    "data-name": "Group 113"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_442",
    "data-name": "Path 442",
    className: "cls-16",
    d: "M64.39,96.85a5.45,5.45,0,0,0-4.48,3.68,4.16,4.16,0,0,0-3.5,3.5c-.81,3.31,1,5.47,3.22,5.65a5.93,5.93,0,0,0,4.76,3.85c4,.81,7.45-3.31,6.1-9C70.5,104.48,71.7,96.41,64.39,96.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_443",
    "data-name": "Path 443",
    className: "cls-16",
    d: "M59.91,100.54a7.48,7.48,0,0,0-1,4.7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_444",
    "data-name": "Path 444",
    className: "cls-16",
    d: "M58.59,109.44a7.36,7.36,0,0,0,3.2.2,4.53,4.53,0,0,0,2.41-.8"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_445",
    "data-name": "Path 445",
    className: "cls-16",
    d: "M60.56,104.16a3.59,3.59,0,0,0-2.12,2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_446",
    "data-name": "Path 446",
    className: "cls-16",
    d: "M69.2,102.5a3.9,3.9,0,0,1,1.3,2"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoctorError);
export default __webpack_public_path__ + "static/media/doctorError.ced3ef7ef4f700c679819e7a7627f661.svg";
export { ForwardRef as ReactComponent };